import moment from "moment"

// パスポート OCR の生年月日の扱い。
//
// API（passportDetection）は "YYYY-MM-DD" で返す。確認ダイアログでは "DD MM YYYY" で見せ、
// 利用者が書き換えることもある。以前はこの表示用の文字列を moment() にそのまま渡して読み直して
// いたため形式の推測に任され、日が12以下なら日と月が入れ替わり、13以上なら "Invalid date" に
// なっていた（同行者は保存が 422 で先へ進めず、代表者は生年月日が黙って捨てられていた）。
// 形式を明示して厳密に読み、読めなければ null にする（生年月日の画面で入力してもらう）。
const OCR_BIRTH_DATE_FORMATS = ["YYYY-MM-DD", "DD MM YYYY", "D M YYYY"]

// 確認ダイアログに出す値。MRZ の読み違いで日付にならないときは空欄にする
export const ocrBirthDateForDisplay = (value) => {
  const date = moment(value, "YYYY-MM-DD", true)
  return date.isValid() ? date.format("DD MM YYYY") : ""
}

// 保存に使う値（"YYYY-MM-DD"）。API の応答とダイアログの表示値のどちらも受け付ける
export const ocrBirthDateToIso = (value) => {
  const date = moment(value, OCR_BIRTH_DATE_FORMATS, true)
  return date.isValid() ? date.format("YYYY-MM-DD") : null
}
